import { render, staticRenderFns } from "./forgetlogin.vue?vue&type=template&id=19a45300&scoped=true&"
import script from "./forgetlogin.vue?vue&type=script&lang=js&"
export * from "./forgetlogin.vue?vue&type=script&lang=js&"
import style0 from "./forgetlogin.vue?vue&type=style&index=0&id=19a45300&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a45300",
  null
  
)

export default component.exports